import React from 'react';
import {Col, Container, Row} from 'reactstrap';
import {FacebookShareButton, FacebookShareCount, TwitterShareButton, PinterestShareButton} from 'react-share';
import {faFacebookF, faTwitter, faPinterestP} from '@fortawesome/free-brands-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import './ShareButtons.scss';
const {SITE_URL} = process.env;

export default function ShareButtons(props) {
  return (
    <>
      {props.floating ? (
        <div className="social-share social-share-floating">
          <ShareButtonsList {...props} />
        </div>
      ) : (
        <>
          {props.shareText ? (
            <div className="social-share-copy d-flex align-items-center justify-content-center">
              <div className="social-share-text mb-2 mb-sm-0 mr-sm-2">Share on social:</div>
              <div className="social-share d-flex align-items-center justify-content-center">
                <ShareButtonsList {...props} noDescription />
              </div>
            </div>
          ) : (
            <div className={classNames('social-share d-flex align-items-center', props.alignment)}>
              <ShareButtonsList {...props} noDescription />
            </div>
          )}
        </>
      )}
    </>
  );
}

ShareButtons.defaultProps = {
  alignment: 'justify-content-center justify-content-lg-end'
};

export function ShareButtonsList({
  shareUrl = `${SITE_URL}masterclass/`,
  shareImg = 'https://cdn.foodrevolution.org/tt2/og/tt2-evergreen-opengraph-landing-1200x1200-v20220804.png',
  facebookDescription = 'Join the free Tackling Type 2 Masterclass to discover top superfoods and free lifestyle tips to stay healthy and feel better than ever. Discover what to stop eating immediately and what the exciting new scientific research tells us about how to stay healthy for life! Learn more here:',
  twitterDescription = 'Join the free Tackling Type 2 Masterclass to discover the real root of Type 2 diabetes — and the all-natural foods and free lifestyle tips to stay healthy! #Diabetes Learn more here:',
  twitterImg = 'https://cdn.foodrevolution.org/tt2/og/tt2-evergreen-opengraph-landing-1200x675-v20220804.png',
  twitterHashtags = [''],
  pinterestDescription = 'Join the free Tackling Type 2 Masterclass to discover top superfoods and free lifestyle tips to stay healthy and feel better than ever. Discover what to stop eating immediately and what the exciting new scientific research tells us about how to stay healthy for life! Learn more here:',
  pinterestImg = 'https://cdn.foodrevolution.org/tt2/og/tt2-evergreen-opengraph-landing-1000x1500-v20220804.png',
  noDescription = false,
  ...props
}) {
  return (
    <>
      {noDescription ? null : (
        <div className="social-button">
          <div className="btn btn-social btn-social-share">Shares</div>
        </div>
      )}

      <FacebookShareButton className="social-button" url={shareUrl} quote={facebookDescription}>
        <div className="btn btn-social btn-social-facebook">
          <FontAwesomeIcon className="social-button-icon" icon={faFacebookF} />
          <span className="btn-social-description btn-social-description-facebook d-none d-md-inline">Facebook</span>
        </div>
      </FacebookShareButton>

      <TwitterShareButton
        className="social-button"
        url={shareUrl}
        via="afoodrevolution"
        media={twitterImg}
        hashtags={twitterHashtags}
        title={twitterDescription}
      >
        <div className="btn btn-social btn-social-twitter">
          <FontAwesomeIcon className="social-button-icon" icon={faTwitter} />
          <span className="btn-social-description btn-social-description-twitter d-none d-md-inline">Twitter</span>
        </div>
      </TwitterShareButton>

      <PinterestShareButton
        className="social-button"
        url={shareUrl}
        media={pinterestImg}
        description={pinterestDescription}
      >
        <div className="btn btn-social btn-social-pinterest">
          <FontAwesomeIcon className="social-button-icon" icon={faPinterestP} />
          <span className="btn-social-description btn-social-description-pinterest d-none d-md-inline">Pinterest</span>
        </div>
      </PinterestShareButton>
    </>
  );
}
